export default "__VITE_ASSET__BiClVVaR__"